
class CleverTapSdk {

    handleEventtracking(eventData, eventName, surveyid) {
        let device = 'pwa';
        try {
            if (window.location.href.indexOf('view=web') != -1 || localStorage.getItem('view') == 'web') {
                device = 'desktop'
            } else if (window.location.href.indexOf('appversionios') != -1 || localStorage.getItem('org_url').indexOf('appversionios') != -1) {
                device = 'iosapp'
            } else if (window.location.href.indexOf('appversionandroid') != -1 || localStorage.getItem('org_url').indexOf('appversionandroid') != -1) {
                device = 'androidapp'
            } else {
                device = 'pwa'
            }
        } catch (error) {

        }

        let user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            eventData['userid'] = user.userid
        }

        eventData['Date'] = new Date();
        eventData['device'] = device;
        eventData['platform'] = device;
        console.log("eventName", eventName);
        console.log("eventData", eventData);
        // alert("Action tracked CT" + JSON.stringify(eventData));
        if (window.clevertap) {
            console.log(window.clevertap.event.push(eventName, eventData));
        } else {
            setTimeout(function () {
                new CleverTapSdk().handleEventtracking(eventData, eventName);
            }, 100)
        }

    }

    handleProfiletrackinig(name) {
        let user = JSON.parse(localStorage.getItem('user'));
        let device = '';
        try {
            if (window.location.href.indexOf('view=web') != -1 || localStorage.getItem('view') == 'web') {
                device = 'desktop'
            } else if (window.location.href.indexOf('appversionios') != -1 || localStorage.getItem('org_url').indexOf('appversionios') != -1) {
                device = 'iosapp'
            } else if (window.location.href.indexOf('appversionandroid') != -1 || localStorage.getItem('org_url').indexOf('appversionandroid') != -1) {
                device = 'androidapp'
            } else {
                device = 'pwa'
            }
        } catch (error) {

        }

        let ctprofile = {}
        ctprofile['name'] = name ? name : user.user_name_display;
        ctprofile['id'] = user.userid;
        ctprofile['device'] = device;
        ctprofile['Identity'] = user.userid;

        // CleverTapSdk.handleEventtracking(ctdata, 'RB2020');
        if (window.clevertap) {
            console.log(window.clevertap.profile.push(ctprofile));
        }else {
            setTimeout(function () {
                new CleverTapSdk().handleProfiletrackinig();
            }, 100)
        }
    }

}

export default new CleverTapSdk;